import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to retrieve city data
import { getTags } from 'models/tags'; // Importing function to retrieve tag data
import { getPositions } from 'models/positions'; // Importing function to retrieve position data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig, profile } from '../../config/config'; // Importing development configuration and profile
import { persons } from '../../models/persons'; // Importing persons model

/**
 * Class representing the InformationBetShopView.
 * @extends JetView
 */
export default class InformationBetShopView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Screen size configuration
        var image; // Variable to hold the first image
        var image2; // Variable to hold the second image
        const lenguages = [ // Array of supported languages
            { id: 'ES', value: 'español (o castellano) (ES)' },
            { id: 'EN', value: 'English (EN)' },
        ];
        const main = { // Main layout configuration
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [ // Columns in the main layout
                {
                    margin: 5,
                    rows: [ // Rows in the first column
                        {
                            cols: [ // Columns in the first row
                                {
                                    view: 'template2', // Template view for displaying DNI Anterior
                                    data: { DNIP: 'data' },
                                    height: 100,
                                    name: 'DNIA',
                                    template: function (obj) { // Template function to render content
                                        image = obj; // Assigning the image to the variable
                                        if (obj != '')
                                            return (
                                                '<h6 style=" margin: 0px; ">' +
                                                _('DNI Anterior') +
                                                "</h6><img class='dniAnterior' src='" +
                                                obj +
                                                "' style='cursor:pointer; width:80px; height:80px;'>"
                                            );
                                        return '<h6 style=" margin: 0px; ">' + _('No tiene DNI Anterior') + '</h6>';
                                    },
                                    onClick: { // Click event for the DNI Anterior image
                                        dniAnterior: function (ev, id) {
                                            webix
                                                .ui({ // Creating a modal window to display the image
                                                    view: 'window',
                                                    head: {
                                                        view: 'toolbar',
                                                        cols: [
                                                            {
                                                                view: 'label',
                                                                label: _('DNI Anterior'),
                                                            },
                                                            {
                                                                view: 'button',
                                                                label: 'X',
                                                                width: 100,
                                                                align: 'right',
                                                                click: "$$('windowDNI').close();", // Close button action
                                                            },
                                                        ],
                                                    },
                                                    id: 'windowDNI',
                                                    modal: true,
                                                    position: 'center',
                                                    body: {
                                                        rows: [
                                                            {
                                                                template: function (obj) {
                                                                    return (
                                                                        "<img src='" +
                                                                        image +
                                                                        "' style='cursor:pointer; width:220px; height:180px;'>"
                                                                    );
                                                                },
                                                            },
                                                        ],
                                                    },
                                                })
                                                .show(); // Show the modal window
                                        },
                                    },
                                },
                                {
                                    rows: [ // Rows in the second column
                                        {
                                            view: 'button', // Button to download the first image
                                            id: 'buttonImage1',
                                            value: _('Descargar'),
                                            width: 100,
                                            disabled: true, // Initially disabled
                                            click: function (obj) {
                                                webix.delay( // Delayed execution for download
                                                    function () {
                                                        var save = document.createElement('a'); // Create an anchor element for download
                                                        save.setAttribute('href', image); // Set the href to the image
                                                        save.setAttribute('target', '_blank');
                                                        save.download = 'imagen.jpg'; // Set the download filename
                                                        save.click(); // Trigger the download
                                                    },
                                                    '',
                                                    '',
                                                    200,
                                                );
                                            },
                                        },
                                        {},
                                    ],
                                },
                            ],
                        },
                        {
                            cols: [ // Columns in the second row
                                {
                                    view: 'template2', // Template view for displaying DNI Posterior
                                    data: { DNIP: 'data' },
                                    height: 100,
                                    name: 'DNIP',
                                    template: function (obj) { // Template function to render content
                                        image2 = obj; // Assigning the image to the variable
                                        if (obj != '')
                                            return (
                                                '<h6 style=" margin: 0px; ">' +
                                                _('DNI Posterior') +
                                                "</h6><img class='dniPorterior' src='" +
                                                obj +
                                                "' style='cursor:pointer; width:80px; height:80px;'>"
                                            );
                                        return '<h6 style=" margin: 0px; ">' + _('No tiene DNI Posterior') + '</h6>';
                                    },
                                    onClick: { // Click event for the DNI Posterior image
                                        dniPorterior: function (ev, id) {
                                            webix
                                                .ui({ // Creating a modal window to display the image
                                                    view: 'window',
                                                    head: {
                                                        view: 'toolbar',
                                                        cols: [
                                                            {
                                                                view: 'label',
                                                                label: _('DNI Posterior'),
                                                            },
                                                            {
                                                                view: 'button',
                                                                label: 'X',
                                                                width: 100,
                                                                align: 'right',
                                                                click: "$$('windowDNIP').close();", // Close button action
                                                            },
                                                        ],
                                                    },
                                                    id: 'windowDNIP',
                                                    modal: true,
                                                    position: 'center',
                                                    body: {
                                                        rows: [
                                                            {
                                                                template: function (obj) {
                                                                    return (
                                                                        "<img src='" +
                                                                        image2 +
                                                                        "' style='cursor:pointer; width:220px; height:180px;'>"
                                                                    );
                                                                },
                                                            },
                                                        ],
                                                    },
                                                })
                                                .show(); // Show the modal window
                                        },
                                    },
                                },
                                {
                                    rows: [ // Rows in the second column
                                        {
                                            view: 'button', // Button to download the second image
                                            id: 'buttonImage2',
                                            value: _('Descargar'),
                                            width: 100,
                                            disabled: true, // Initially disabled
                                            click: function (obj) {
                                                webix.delay( // Delayed execution for download
                                                    function () {
                                                        var save = document.createElement('a'); // Create an anchor element for download
                                                        save.setAttribute('href', image2); // Set the href to the image
                                                        save.setAttribute('target', '_blank');
                                                        save.download = 'imagen.jpg'; // Set the download filename
                                                        save.click(); // Trigger the download
                                                    },
                                                    '',
                                                    '',
                                                    200,
                                                );
                                            },
                                        },
                                        {},
                                    ],
                                },
                            ],
                        },
                        {
                            view: 'text', // Text input for user ID
                            name: 'Id',
                            label: _('Número de usuario'),
                            labelPosition: 'top',
                            placeholder: _('Número de usuario'),
                            disabled: true, // Initially disabled
                        },
                        {
                            view: 'text', // Text input for login
                            name: 'Login',
                            label: _('Login para acceso'),
                            labelPosition: 'top',
                            placeholder: _('Login para acceso'),
                        },
                        {
                            view: 'text', // Text input for balance assigned
                            name: 'BalanceAssigned',
                            label: _('Saldo de comisión'),
                            labelPosition: 'top',
                            placeholder: _('Saldo de comisión'),
                            disabled: true, // Initially disabled
                        },
                        {
                            view: 'text', // Text input for last IP address
                            name: 'LastIPaddress',
                            label: _('Última dirección IP'),
                            labelPosition: 'top',
                            placeholder: _('Última dirección IP'),
                            disabled: true, // Initially disabled
                        },
                        {
                            view: 'text', // Text input for last modified user
                            name: 'LastModifiedUser',
                            label: _('Último usuario modif'),
                            labelPosition: 'top',
                            placeholder: _('Último usuario modif'),
                            disabled: true, // Initially disabled
                        },
                        {
                            view: 'richselect', // Dropdown for user state
                            name: 'State',
                            localId: 'State:combo',
                            label: _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [ // Options for the state dropdown
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                                { id: 'R', value: _('Retirado') },
                            ],
                            disabled: true, // Initially disabled
                        },
                        {
                            view: 'richselect', // Dropdown for preferred language
                            name: 'PreferredLanguage',
                            localId: 'PreferredLanguage:combo',
                            label: _('Idioma preferido:'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: lenguages, // Options from the languages array
                        },
                        {
                            view: 'text', // Text input for user name
                            name: 'Name',
                            label: _('Nombre del usuario'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del usuario'),
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountryId',
                            id: 'country',
                            localId: 'Country:combo',
                            label: _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Empty options initially
                            disabled: true, // Initially disabled
                        },
                        {
                            view: 'richselect', // Dropdown for currency selection
                            name: 'CurrencyId',
                            id: 'currency',
                            localId: 'Currency:combo',
                            label: _('Moneda'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Empty options initially
                            disabled: true, // Initially disabled
                        },
                        {
                            view: 'text', // Text input for creation date
                            name: 'CreatedLocalDate',
                            label: _('Fecha de creación'),
                            labelPosition: 'top',
                            placeholder: _('Fecha de creación'),
                            disabled: true, // Initially disabled
                        },
                        {
                            view: 'text', // Text input for last login date
                            name: 'LastLoginLocalDate',
                            label: _('Fecha última entrada'),
                            labelPosition: 'top',
                            placeholder: _('Fecha última entrada'),
                            disabled: true, // Initially disabled
                        },
                        {
                            view: 'text', // Text input for last modified date
                            name: 'LastDateModified',
                            label: _('Última Fecha modif'),
                            labelPosition: 'top',
                            placeholder: _('Última Fecha modif'),
                            disabled: true, // Initially disabled
                        },
                        {
                            view: 'textarea', // Text area for notes
                            name: 'Note',
                            label: _('Observación'),
                            labelPosition: 'top',
                            placeholder: _('Observación'),
                            disabled: false, // Not disabled
                            height: 150,
                        },
                        {
                            view: 'richselect', // Dropdown for establishment type
                            name: 'TypeEstablishment',
                            id: 'TypeEstablishment',
                            localId: 'TypeEstablishment:combo',
                            label: _('Tipo establecimiento'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [], // Empty options initially
                        },
                        {
                            view: 'richselect', // Dropdown for commission payment
                            name: 'ComissionsPayment',
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility
                            localId: 'State:combo',
                            label: "<span class='icon-state'></span>" + _('Pago de comisiones'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [ // Options for commission payment
                                { id: 'S', value: _('Saldo') },
                                { id: 'F', value: _('Factura') },
                            ],
                        },
                    ],
                },
            ],
        };

        /**
         * Configuration object for the main cashier interface.
         * @type {Object}
         * @property {number} padding - Padding around the main cashier component.
         * @property {number} margin - Margin around the main cashier component.
         * @property {number} minWidth - Minimum width of the main cashier component.
         * @property {Array} cols - Array of column configurations for the cashier layout.
         */
        const main_cashier = {
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            view: 'text', // Text input for user ID
                            name: 'Id',
                            label: _('Número de usuario'), // Label for the input
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Número de usuario'), // Placeholder text
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for login
                            name: 'Login',
                            label: _('Login para acceso'),
                            labelPosition: 'top',
                            placeholder: _('Login para acceso'),
                        },
                        {
                            view: 'text', // Text input for last IP address
                            name: 'LastIPaddress',
                            label: _('Última dirección IP'),
                            labelPosition: 'top',
                            placeholder: _('Última dirección IP'),
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for last modified user
                            name: 'LastModifiedUser',
                            label: _('Último usuario modif'),
                            labelPosition: 'top',
                            placeholder: _('Último usuario modif'),
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State',
                            localId: 'State:combo',
                            label: _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'A', value: _('Activo') }, // Active state option
                                { id: 'I', value: _('Inactivo') }, // Inactive state option
                            ],
                            disabled: true, // Dropdown is disabled
                        },
                        {
                            view: 'richselect', // Dropdown for preferred language selection
                            name: 'PreferredLanguage',
                            localId: 'PreferredLanguage:combo',
                            label: _('Idioma preferido:'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: lenguages, // Options for languages
                        },
                        {
                            view: 'text', // Text input for user name
                            name: 'Name',
                            label: _('Nombre del usuario'),
                            labelPosition: 'top',
                            placeholder: _('Nombre del usuario'),
                        },
                        {
                            view: 'text', // Text input for creation date
                            name: 'CreatedLocalDate',
                            label: _('Fecha de creación'),
                            labelPosition: 'top',
                            placeholder: _('Fecha de creación'),
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for last login date
                            name: 'LastLoginLocalDate',
                            label: _('Fecha última entrada'),
                            labelPosition: 'top',
                            placeholder: _('Fecha última entrada'),
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for last modified date
                            name: 'LastDateModified',
                            label: _('Última Fecha modif'),
                            labelPosition: 'top',
                            placeholder: _('Última Fecha modif'),
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for latitude
                            name: 'Latitud',
                            type: 'number', // Input type is number
                            label: _('Latitud'),
                            labelPosition: 'top',
                            placeholder: _('Latitud'),
                        },
                        {
                            view: 'text', // Text input for longitude
                            name: 'Longitud',
                            type: 'number', // Input type is number
                            label: _('Longitud'),
                            labelPosition: 'top',
                            placeholder: _('Longitud'),
                        },
                        {
                            view: 'text', // Text input for IP address
                            name: 'IP',
                            type: 'number', // Input type is number
                            label: _('IP'),
                            labelPosition: 'top',
                            placeholder: _('IP'),
                        },
                        {
                            view: 'text', // Text input for daily quota reloads
                            name: 'DailyQuotaReloads',
                            type: 'number', // Input type is number
                            label: _('Limite diario de recargas'),
                            labelPosition: 'top',
                            placeholder: _('Limite diario de recargas'),
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for minimum bet
                            name: 'MinimumBet',
                            type: 'number', // Input type is number
                            label: _('Apuesta mínima'),
                            labelPosition: 'top',
                            placeholder: _('Apuesta mínima'),
                        },
                        {
                            view: 'text', // Text input for daily limit
                            name: 'DailyLimit',
                            type: 'number', // Input type is number
                            label: _('Límite diario'),
                            labelPosition: 'top',
                            placeholder: _('Límite diario'),
                        },
                        {
                            view: 'text', // Text input for maximum withdrawal amount
                            name: 'MaximumWithdrawalAmount',
                            type: 'number', // Input type is number
                            label: _('Máximo monto por retiro'),
                            labelPosition: 'top',
                            placeholder: _('Máximo monto por retiro'),
                        },
                        {
                            view: 'text', // Text input for maximum prize payment amount
                            name: 'MaximumPrizePaymentAmount',
                            type: 'number', // Input type is number
                            label: _('Máximo monto pago premio'),
                            labelPosition: 'top',
                            placeholder: _('Máximo monto pago premio'),
                        },
                    ],
                },
            ],
        };
        /**
         * Configuration object for the main options of the UI component.
         * @type {Object}
         * @property {number} padding - Padding around the main container.
         * @property {number} margin - Margin around the main container.
         * @property {number} minWidth - Minimum width of the main container.
         * @property {Array} cols - Array of column configurations.
         */
        const options_main = {
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            rows: [
                                { view: 'label', label: _('Estado especial') }, // Label for special status
                                {
                                    id: 'SpecialStatus', // ID for the switch component
                                    view: 'switch', // Switch component for toggling status
                                    onLabel: _('Activo'), // Label when switch is ON
                                    offLabel: _('Inactivo'), // Label when switch is OFF
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Bloqueado para ventas'), // Label for sales lock status
                                },
                                {
                                    id: 'Lockedsales', // ID for the sales lock switch
                                    view: 'switch', // Switch component for sales lock
                                    onLabel: _('Si'), // Label when switch is ON
                                    offLabel: _('No'), // Label when switch is OFF
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Imprime recibo caja'), // Label for receipt printing status
                                },
                                {
                                    id: 'PrintReceiptBox', // ID for the receipt printing switch
                                    view: 'switch', // Switch component for receipt printing
                                    onLabel: _('Si'), // Label when switch is ON
                                    offLabel: _('No'), // Label when switch is OFF
                                },
                            ],
                        },
                        {
                            rows: [
                                { view: 'label', label: _('Permite recargas') }, // Label for recharge permission
                                {
                                    id: 'AllowsRecharges', // ID for the recharge permission switch
                                    view: 'switch', // Switch component for recharge permission
                                    onLabel: _('Si'), // Label when switch is ON
                                    offLabel: _('No'), // Label when switch is OFF
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Permite activar reg'), // Label for registration activation permission
                                },
                                {
                                    id: 'ActivateRegistration', // ID for the registration activation switch
                                    view: 'switch', // Switch component for registration activation
                                    onLabel: _('Si'), // Label when switch is ON
                                    offLabel: _('No'), // Label when switch is OFF
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Programa de identificación de IP Activo'), // Label for IP identification status
                                },
                                {
                                    id: 'IPIdentification', // ID for the IP identification switch
                                    view: 'switch', // Switch component for IP identification
                                    value: 0, // Default value for the switch
                                    onLabel: _('Si'), // Label when switch is ON
                                    offLabel: _('No'), // Label when switch is OFF
                                },
                            ],
                        },
                        {
                            rows: [
                                { view: 'label', label: _('Visita realizada') }, // Label for visit status
                                {
                                    id: 'VisitMade', // ID for the visit status switch
                                    view: 'switch', // Switch component for visit status
                                    value: 0, // Default value for the switch
                                    onLabel: _('Si'), // Label when switch is ON
                                    offLabel: _('No'), // Label when switch is OFF
                                },
                            ],
                        },
                        {
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Documentación Recibida'), // Label for documentation received status
                                },
                                {
                                    id: 'DocumentationReceived', // ID for the documentation received switch
                                    view: 'switch', // Switch component for documentation received
                                    value: 0, // Default value for the switch
                                    onLabel: _('Si'), // Label when switch is ON
                                    offLabel: _('No'), // Label when switch is OFF
                                },
                            ],
                        },
                        {
                            view: 'text', // Text input for latitude
                            name: 'Latitud', // Name of the input field
                            type: 'number', // Input type
                            label: _('Latitud'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Latitud'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for longitude
                            name: 'Longitud', // Name of the input field
                            type: 'number', // Input type
                            label: _('Longitud'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Longitud'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for IP address
                            name: 'IP', // Name of the input field
                            type: 'number', // Input type
                            label: _('IP'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('IP'), // Placeholder text
                        },
                        {
                            view: 'textarea', // Textarea for header of prize payment receipt
                            name: 'HeaderPrintPrizePaymentReceipt', // Name of the input field
                            label: _('Parte Superior Impresión recibo de pago de premio'), // Label for the textarea
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Parte Superior Impresión recibo de pago de premio'), // Placeholder text
                            disabled: false, // Indicates if the textarea is disabled
                            height: 100, // Height of the textarea
                        },
                        {
                            view: 'textarea', // Textarea for footer of prize payment receipt
                            name: 'FooterPrintPrizePaymentReceipt', // Name of the input field
                            label: _('Parte Inferior Impresión recibo de pago de premio'), // Label for the textarea
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Parte Inferior Impresión recibo de pago de premio'), // Placeholder text
                            disabled: false, // Indicates if the textarea is disabled
                            height: 100, // Height of the textarea
                        },
                        {
                            view: 'textarea', // Textarea for header of retirement payment receipt
                            name: 'HeaderPrintRetirementPaymentReceipt', // Name of the input field
                            label: _('Parte Superior Impresión recibo de pago de retiro'), // Label for the textarea
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Parte Superior Impresión recibo de pago de retiro'), // Placeholder text
                            disabled: false, // Indicates if the textarea is disabled
                            height: 100, // Height of the textarea
                        },
                        {
                            view: 'textarea', // Textarea for footer of retirement payment receipt
                            name: 'FooterPrintRetirementPaymentReceipt', // Name of the input field
                            label: _('Parte Inferior Impresión recibo de pago de retiro'), // Label for the textarea
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Parte Inferior Impresión recibo de pago de retiro'), // Placeholder text
                            disabled: false, // Indicates if the textarea is disabled
                            height: 100, // Height of the textarea
                        },
                    ],
                },
            ],
        };
        /**
         * Configuration object for betshop details form layout.
         * @type {Object}
         * @property {number} padding - Padding around the form.
         * @property {number} margin - Margin around the form.
         * @property {number} minWidth - Minimum width of the form.
         * @property {Array} cols - Array of column configurations.
         */
        const betshop_details = {
            padding: 15,
            margin: 15,
            minWidth: 250,
            cols: [
                {
                    margin: 5,
                    rows: [
                        {
                            view: 'text', // Text input for contact name
                            name: 'ContactName',
                            label: _('Nombre del contacto'), // Label in Spanish
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Nombre del contacto'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for document number
                            name: 'Document',
                            type: 'number', // Input type is number
                            label: _('Número cédula'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Numero cédula'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for email
                            name: 'Email',
                            label: _('Correo electrónico'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Correo electrónico'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for description
                            name: 'Description',
                            label: _('Descripción'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Descripción'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for phone number
                            name: 'Phone',
                            type: 'number', // Input type is number
                            label: _('Teléfono'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Teléfono'), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for concessionaire selection
                            name: 'Concessionaire',
                            id: 'Concessionaire',
                            localId: 'Concessionaire:combo',
                            label: _('Concesionario'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                        },
                        {
                            view: 'richselect', // Dropdown for subconcessionaire selection
                            name: 'Subconcessionaire',
                            id: 'Subconcessionaire',
                            localId: 'Subconcessionaire:combo',
                            label: _('Subconcesionario'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                        },
                        {
                            view: 'richselect', // Dropdown for second subconcessionaire selection
                            name: 'Subconcessionaire2',
                            id: 'Subconcessionaire2',
                            localId: 'Subconcessionaire2:combo',
                            label: _('Subconcesionario 2'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                        },
                        {
                            view: 'combo', // Dropdown for region profile selection
                            name: 'RegionPerfil',
                            minWidth: 200,
                            label: _('Región Perfil'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            hidden: profile.PartnerSelected != 8, // Conditional visibility
                            options: [
                                { id: 'CENTRO', value: _('CENTRO') }, // Option for 'CENTRO'
                                { id: 'COSTA', value: _('COSTA') }, // Option for 'COSTA'
                                { id: 'AUSTRO', value: _('AUSTRO') }, // Option for 'AUSTRO'
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for province/region selection
                            name: 'RegionId',
                            id: 'ProvinceRegion',
                            localId: 'ProvinceRegion:combo',
                            label: _('Provincia/Región'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                        },
                        {
                            view: 'richselect', // Dropdown for city selection
                            name: 'CityId',
                            id: 'City',
                            localId: 'City:combo',
                            label: _('Ciudad'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                        },
                        {
                            view: 'richselect', // Dropdown for zone selection
                            name: 'Zone',
                            id: 'Zone',
                            label: "<span class='icon-language'></span>" + _('Zona'), // Label in Spanish with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                        },
                        {
                            view: 'text', // Text input for address
                            name: 'Address',
                            label: _('Dirección'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Dirección'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for district
                            name: 'District',
                            label: _('Barrio'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Barrio'), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for custom cost center
                            name: 'CustomCostCenter',
                            label: _('Centro de costo personalizado'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Centro de costo personalizado'), // Placeholder text
                        },
                        {
                            view: 'combo', // Dropdown for accounting account selection
                            name: 'Account',
                            id: 'AccountFilter',
                            label: _('Cuenta Contable'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'combo', // Dropdown for accounting close account selection
                            name: 'AccountClose',
                            id: 'AccountCloseFilter',
                            label: _('Cuenta Contable Cierre'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for Facebook link
                            name: 'Facebook',
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility
                            label: _('Facebook'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Facebook'), // Placeholder text
                            required: false, // Not a required field
                            invalidMessage: _('Campo Requerido'), // Message for invalid input
                        },
                        {
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Facebook Verificado'), // Label in Spanish
                                },
                                {
                                    id: 'FacebookVerification',
                                    view: 'switch', // Switch for Facebook verification
                                    onLabel: _('Si'), // Label for 'Yes'
                                    offLabel: _('No'), // Label for 'No'
                                },
                            ],
                        },
                        {
                            view: 'text', // Text input for Instagram link
                            name: 'Instagram',
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility
                            label: _('Instagram'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Instagram'), // Placeholder text
                        },
                        {
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Instagram Verificado'), // Label in Spanish
                                },
                                {
                                    id: 'InstagramVerification',
                                    view: 'switch', // Switch for Instagram verification
                                    onLabel: _('Si'), // Label for 'Yes'
                                    offLabel: _('No'), // Label for 'No'
                                },
                            ],
                        },
                        {
                            view: 'text', // Text input for WhatsApp link
                            name: 'WhatsApp',
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility
                            label: _('WhatsApp'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('WhatsApp'), // Placeholder text
                        },
                        {
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility
                            rows: [
                                {
                                    view: 'label',
                                    label: _('WhatsApp Verificado'), // Label in Spanish
                                },
                                {
                                    id: 'WhatsAppVerification',
                                    view: 'switch', // Switch for WhatsApp verification
                                    onLabel: _('Si'), // Label for 'Yes'
                                    offLabel: _('No'), // Label for 'No'
                                },
                            ],
                        },
                        {
                            view: 'text', // Text input for other social media links
                            name: 'OtherSocialMedia',
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility
                            label: _('Otras Redes Sociales'), // Label in Spanish
                            labelPosition: 'top',
                            placeholder: _('Otras Redes Sociales'), // Placeholder text
                        },
                        {
                            hidden: devConfig.getPartnerSelected() != '8', // Conditional visibility
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Otras Redes Sociales Verificado'), // Label in Spanish
                                },
                                {
                                    id: 'OtherSocialMediaVerification',
                                    view: 'switch', // Switch for other social media verification
                                    onLabel: _('Si'), // Label for 'Yes'
                                    offLabel: _('No'), // Label for 'No'
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        // Restricts a numeric text field to digits only (blocks '-', '.', letters, etc.)
        const digitsOnlyHandlers = {
            onBeforePaste: function (text) {
                return String(text).replace(/\D+/g, '');
            },
            onKeyPress: function (code) {
                return (
                    (code >= 48 && code <= 57) || // digits
                    code === 8 || // backspace
                    code === 9 || // tab
                    code === 13 || // enter
                    code === 46 || // delete
                    code === 37 || // arrow left
                    code === 39 // arrow right
                );
            },
            onTimedKeyPress: function () {
                var clean = String(this.getValue() || '').replace(/\D+/g, '');
                if (this.getValue() !== clean) this.setValue(clean);
            },
        };
        /**
         * Configuration object for the center-right section of the UI.
         * Contains layout properties and form fields for user input.
         */
        const center_right = {
            /** Padding around the section */
            padding: 15,
            /** Margin around the section */
            margin: 15,
            /** Minimum width of the section */
            minWidth: 250,
            /** Array of column configurations */
            cols: [
                {
                    /** Margin for the column */
                    margin: 5,
                    /** Array of row configurations within the column */
                    rows: [
                        {
                            /** Text input for daily reload quota */
                            view: 'text',
                            name: 'DailyQuotaReloads',
                            type: 'number',
                            /** Label for the input field */
                            label: _('Limite diario de recargas'),
                            /** Position of the label */
                            labelPosition: 'top',
                            /** Placeholder text for the input field */
                            placeholder: _('Limite diario de recargas'),
                            /** Indicates if the input is disabled */
                            disabled: false,
                        },
                        {
                            /** Text input for minimum recharge amount */
                            view: 'text',
                            name: 'MinimumRechargeAmount',
                            id: 'MinimumRechargeAmount',
                            type: 'number',
                            label: _('Monto mínimo de recarga'),
                            labelPosition: 'top',
                            placeholder: _('Monto mínimo de recarga'),
                            invalidMessage: _('Ingresa un monto de recarga válido. Solo se permiten valores numéricos positivos.'),
                            disabled: !devConfig.getPermAction('betShopRechargeAmountsUpdate', 'Update'), // Editable only with the permission
                            on: digitsOnlyHandlers,
                        },
                        {
                            /** Text input for maximum recharge amount */
                            view: 'text',
                            name: 'MaximumRechargeAmount',
                            id: 'MaximumRechargeAmount',
                            type: 'number',
                            label: _('Monto máximo de recarga'),
                            labelPosition: 'top',
                            placeholder: _('Monto máximo de recarga'),
                            invalidMessage: _('Ingresa un monto de recarga válido. Solo se permiten valores numéricos positivos.'),
                            disabled: !devConfig.getPermAction('betShopRechargeAmountsUpdate', 'Update'), // Editable only with the permission
                            on: digitsOnlyHandlers,
                        },
                        {
                            /** Text input for minimum bet amount */
                            view: 'text',
                            name: 'MinimumBet',
                            type: 'number',
                            label: _('Apuesta mínima'),
                            labelPosition: 'top',
                            placeholder: _('Apuesta mínima'),
                        },
                        {
                            /** Text input for daily limit */
                            view: 'text',
                            name: 'DailyLimit',
                            type: 'number',
                            label: _('Límite diario'),
                            labelPosition: 'top',
                            placeholder: _('Límite diario'),
                        },
                        {
                            /** Text input for maximum withdrawal amount */
                            view: 'text',
                            name: 'MaximumWithdrawalAmount',
                            type: 'number',
                            label: _('Máximo monto por retiro'),
                            labelPosition: 'top',
                            placeholder: _('Máximo monto por retiro'),
                        },
                        {
                            /** Text input for maximum prize payment amount */
                            view: 'text',
                            name: 'MaximumPrizePaymentAmount',
                            type: 'number',
                            label: _('Máximo monto pago premio'),
                            labelPosition: 'top',
                            placeholder: _('Máximo monto pago premio'),
                        },
                        {
                            /** Text input for prize payment tax */
                            view: 'text',
                            name: 'PrizePaymentTax',
                            type: 'number',
                            label: _('Impuesto al pago de premio (GGR)'),
                            labelPosition: 'top',
                            placeholder: _('Impuesto al pago de premio (GGR)'),
                        },
                        {
                            /** Text input for Mincetur point of sale code */
                            view: 'text',
                            name: 'CodeMinceturPv',
                            id: 'CodeMinceturPv',
                            label: _('CÓDIGO DE PUNTO DE VENTA MINCETUR'),
                            labelPosition: 'top',
                            placeholder: _('Codigo'),
                        },
                        {
                            /** Row for individual calculation switch */
                            rows: [
                                {
                                    /** Label for individual calculation */
                                    view: 'label',
                                    label: _('Cálculo Individual'),
                                },
                                {
                                    /** Switch for enabling/disabling individual calculation */
                                    id: 'IndividualCalculation',
                                    view: 'switch',
                                    onLabel: _('Si'),
                                    offLabel: _('No'),
                                },
                            ],
                        },
                        {
                            /** Row for dragging negatives switch */
                            rows: [
                                {
                                    /** Label for dragging negatives */
                                    view: 'label',
                                    label: _('Arrastra Negativos'),
                                },
                                {
                                    /** Switch for enabling/disabling dragging negatives */
                                    id: 'DragNegatives',
                                    view: 'switch',
                                    onLabel: _('Si'),
                                    offLabel: _('No'),
                                },
                            ],
                        },
                        {
                            /** Row for indicating if the bet shop is owned */
                            rows: [
                                { view: 'label', label: _('Es Propio?') },
                                {
                                    /** Switch for indicating ownership of the bet shop */
                                    id: 'BetShopOwn',
                                    view: 'switch',
                                    onLabel: _('Si'),
                                    offLabel: _('No'),
                                },
                            ],
                        },
                        {
                            /** Row for selecting the type of bet shop */
                            rows: [
                                { view: 'label', label: _('Tipo de Punto') },
                                {
                                    /** Switch for selecting physical or virtual bet shop */
                                    id: 'BetShopType',
                                    view: 'switch',
                                    onLabel: _('Físico'),
                                    offLabel: _('Virtual'),
                                },
                            ],
                        },
                        {
                            /** Row for indicating if physical prizes are delivered */
                            rows: [
                                {
                                    view: 'label',
                                    label: _('Entrega Premio Físico?'),
                                },
                                {
                                    /** Switch for indicating physical prize delivery */
                                    id: 'PhysicalPrize',
                                    view: 'switch',
                                    onLabel: _('Si'),
                                    offLabel: _('No'),
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const right = { // Right section layout
            margin: 5,
            rows: [],
        };
        const upper_section = { // Upper section layout
            id: 'b5',
            hidden: true, // Initially hidden
            rows: [
                {
                    collapsed: false,
                    multi: true,
                    view: 'accordion', // Accordion layout for sections
                    css: 'betShop',
                    margin: 15,
                    responsive: 'b5',
                    cols: [
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Principales'), // Header for main data section
                                    body: {
                                        rows: [main], // Main data layout
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Configuración'), // Header for configuration data section
                                    body: {
                                        rows: [options_main], // Configuration options layout
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Datos Punto de venta'), // Header for point of sale data section
                                    body: {
                                        rows: [betshop_details], // Point of sale details layout
                                    },
                                },
                            ],
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Configuración Punto de Venta'), // Header for point of sale configuration section
                                    body: {
                                        rows: [center_right], // Point of sale configuration layout
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    collapsed: false,
                    multi: true,
                    view: 'accordion', // Accordion layout for user limits section
                    css: 'betShop',
                    margin: 15,
                    responsive: 'b5',
                    cols: [
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    header: _('Límites Usuarios'), // Header for user limits section
                                    body: {
                                        rows: [
                                            {
                                                padding: 15,
                                                margin: 15,
                                                minWidth: 250,
                                                cols: [
                                                    {
                                                        margin: 5,
                                                        rows: [
                                                            {
                                                                view: 'form', // Form for withdrawal limits
                                                                rows: [
                                                                    {
                                                                        id: 'IsActiveWithdrawalLimit', // Switch for activating withdrawal limit
                                                                        view: 'switch',
                                                                        labelPosition: 'left',
                                                                        label: _('Retiros'),
                                                                        labelWidth: 100,
                                                                        onLabel: _('Si'),
                                                                        offLabel: _('No'),
                                                                        on: {
                                                                            onChange: function (newv, oldv) { // Change event for the switch
                                                                                if (newv === 1) {
                                                                                    $$('WithdrawalLimit').show(); // Show limit input if activated
                                                                                } else {
                                                                                    $$('WithdrawalLimit').hide(); // Hide limit input if deactivated
                                                                                }
                                                                            },
                                                                        },
                                                                    },
                                                                    {
                                                                        hidden: true, // Hidden input for withdrawal limit
                                                                        view: 'text',
                                                                        name: 'WithdrawalLimit',
                                                                        id: 'WithdrawalLimit',
                                                                        label: _('Limite'),
                                                                        labelPosition: 'left',
                                                                        placeholder: 'Limite',
                                                                        invalidMessage: 'Campo Requerido', // Validation message
                                                                        type: 'number',
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                view: 'form', // Form for deposit limits
                                                                rows: [
                                                                    {
                                                                        id: 'IsActiveDepositLimit', // Switch for activating deposit limit
                                                                        view: 'switch',
                                                                        labelPosition: 'left',
                                                                        label: _('Depósitos'),
                                                                        labelWidth: 100,
                                                                        onLabel: _('Si'),
                                                                        offLabel: _('No'),
                                                                        on: {
                                                                            onChange: function (newv, oldv) { // Change event for the switch
                                                                                if (newv === 1) {
                                                                                    $$('DepositLimit').show(); // Show limit input if activated
                                                                                } else {
                                                                                    $$('DepositLimit').hide(); // Hide limit input if deactivated
                                                                                }
                                                                            },
                                                                        },
                                                                    },
                                                                    {
                                                                        hidden: true, // Hidden input for deposit limit
                                                                        view: 'text',
                                                                        name: 'DepositLimit',
                                                                        id: 'DepositLimit',
                                                                        label: _('Limite'),
                                                                        labelPosition: 'left',
                                                                        placeholder: 'Limite',
                                                                        invalidMessage: 'Campo Requerido', // Validation message
                                                                        type: 'number',
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                        {
                            hidden: devConfig.getPermAction('WithdrawalDepositLimitsAlliedNetworks', 'Add'), // Conditional visibility based on permissions
                        },
                        {
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            hidden: !devConfig.getPermAction('WithdrawalDepositLimitsAlliedNetworks', 'Add'), // Conditional visibility based on permissions
                            rows: [
                                {
                                    header: _('Límites Redes Aliadas'), // Header for allied networks limits section
                                    body: {
                                        rows: [
                                            {
                                                padding: 15,
                                                margin: 15,
                                                minWidth: 250,
                                                cols: [
                                                    {
                                                        margin: 5,
                                                        rows: [
                                                            {
                                                                id: 'IsActivatePayWithdrawalAllies', // Switch for activating withdrawal limits for allies
                                                                view: 'switch',
                                                                labelPosition: 'left',
                                                                label: _('Retiros'),
                                                                labelWidth: 100,
                                                                onLabel: _('Si'),
                                                                offLabel: _('No'),
                                                            },
                                                            {
                                                                view: 'form', // Form for withdrawal limits for allies
                                                                rows: [
                                                                    {
                                                                        id: 'IsActiveWithdrawalLimitAllies', // Switch for activating withdrawal limit for allies
                                                                        view: 'switch',
                                                                        labelPosition: 'top',
                                                                        labelWidth: 110,
                                                                        label: _('Restricción Retiros'),
                                                                        onLabel: _('Si'),
                                                                        offLabel: _('No'),
                                                                    },
                                                                    {
                                                                        view: 'text',
                                                                        name: 'WithdrawalLimitAllies', // Input for withdrawal limit for allies
                                                                        id: 'WithdrawalLimitAllies',
                                                                        label: _('Limite Retiros Diario'),
                                                                        labelPosition: 'top',
                                                                        placeholder: 'Limite',
                                                                        default: 0,
                                                                        type: 'number',
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                view: 'form', // Form for deposit limits for allies
                                                                rows: [
                                                                    {
                                                                        id: 'IsActiveDepositLimitAllies', // Switch for activating deposit limit for allies
                                                                        view: 'switch',
                                                                        labelPosition: 'top',
                                                                        labelWidth: 110,
                                                                        label: _('Restricción Depósitos'),
                                                                        onLabel: _('Si'),
                                                                        offLabel: _('No'),
                                                                    },
                                                                    {
                                                                        view: 'text',
                                                                        name: 'DepositLimitAllies', // Input for deposit limit for allies
                                                                        id: 'DepositLimitAllies',
                                                                        label: _('Limite Depósitos Diario'),
                                                                        labelPosition: 'top',
                                                                        placeholder: 'Limite',
                                                                        default: 0,
                                                                        invalidMessage: 'Campo Requerido', // Validation message
                                                                        type: 'number',
                                                                    },
                                                                ],
                                                            },
                                                            {
                                                                view: 'datatable', // Data table for allowed concessionaires
                                                                id: 'IdsAllowed',
                                                                name: 'IdsAllowed',
                                                                height: 300,
                                                                columns: [
                                                                    {
                                                                        id: 'ch1',
                                                                        header: [
                                                                            {
                                                                                content: 'masterCheckbox', // Checkbox for selecting all
                                                                            },
                                                                        ],
                                                                        checkValue: 'on',
                                                                        uncheckValue: 'off',
                                                                        template: '{common.checkbox()}', // Checkbox template
                                                                        width: 40,
                                                                    },
                                                                    {
                                                                        id: 'title',
                                                                        header: [
                                                                            {
                                                                                text: 'Concesionarios Habilitados', // Header for allowed concessionaires
                                                                            },
                                                                            {
                                                                                content: 'textFilter', // Text filter for searching
                                                                            },
                                                                        ],
                                                                        fillspace: true,
                                                                        sort: 'string',
                                                                        css: {
                                                                            'text-align': 'left',
                                                                        },
                                                                    },
                                                                ],
                                                                scrollX: false,
                                                                navigation: true,
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                        {},
                        {},
                    ],
                },
            ],
        };

        /**
         * Configuration object for the upper section of the cashier interface.
         * @type {Object}
         * @property {string} id - Unique identifier for the upper section cashier.
         * @property {boolean} hidden - Indicates whether the section is hidden by default.
         * @property {Array} rows - Array of row configurations for the section.
         */
        const upper_section_cashier = {
            id: 'upper_section_cashier',
            hidden: true,
            rows: [
                {
                    /**
                     * Configuration for the first row in the upper section.
                     * @type {Object}
                     * @property {boolean} collapsed - Indicates if the row is collapsed.
                     * @property {boolean} multi - Allows multiple items in the row.
                     * @property {string} view - The type of view for the row (accordion).
                     * @property {string} css - CSS class for styling the row.
                     * @property {number} margin - Margin around the row.
                     * @property {string} responsive - Responsive design setting.
                     * @property {Array} cols - Array of column configurations within the row.
                     */
                    collapsed: false,
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    margin: 15,
                    responsive: 'b5',
                    cols: [
                        {
                            /**
                             * Configuration for the first column in the row.
                             * @type {Object}
                             * @property {boolean} multi - Allows multiple items in the column.
                             * @property {string} view - The type of view for the column (accordion).
                             * @property {string} css - CSS class for styling the column.
                             * @property {boolean} collapsed - Indicates if the column is collapsed.
                             * @property {number} paddingY - Vertical padding for the column.
                             * @property {string} type - Type of the column (clean).
                             * @property {Array} rows - Array of row configurations within the column.
                             */
                            multi: true,
                            view: 'accordion',
                            css: 'betShop',
                            collapsed: false,
                            paddingY: 10,
                            type: 'clean',
                            rows: [
                                {
                                    /**
                                     * Header configuration for the row.
                                     * @type {Object}
                                     * @property {string} header - Title displayed in the header.
                                     * @property {Object} body - Body configuration containing rows.
                                     */
                                    header: _('Datos Principales'), // Translated title for main data
                                    body: {
                                        rows: [main_cashier], // Main cashier content
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        const buttons = { // Button layout configuration
            margin: 10,
            cols: [
                { id: 'grav' },
                {
                    view: 'button', // Save button
                    id: 'buttonSave',
                    value: _('Guardar'),
                    type: 'form',
                    width: screen == 'small' ? 0 : 200, // Conditional width based on screen size
                    autowidth: false,
                    disabled: true, // Initially disabled
                    click: () => { // Click event for save button
                        const newdata = this.getRoot().getValues(); // Get form values
                        // Validate recharge amount fields (optional, zero or positive numbers, min <= max).
                        // The backend stores an unset amount as 0 (e.g. when the field was left empty on a
                        // previous save), so 0 must be accepted as a valid value here too — otherwise simply
                        // reopening and resaving a record that already has 0 would fail validation.
                        if ($$('MinimumRechargeAmount') != undefined && $$('MaximumRechargeAmount') != undefined) {
                            const isValidRechargeAmount = (val) => val === '' || (/^\d+(\.\d+)?$/.test(val) && parseFloat(val) >= 0);
                            const minRecharge = $$('MinimumRechargeAmount').getValue();
                            const maxRecharge = $$('MaximumRechargeAmount').getValue();
                            // Full text for the modal/toast (plenty of room to wrap there).
                            const invalidAmountMessage = _(
                                'Ingresa un monto de recarga válido. Solo se permiten valores numéricos positivos.',
                            );
                            const invalidRangeMessage = _(
                                'El monto mínimo de recarga no puede ser mayor al monto máximo de recarga.',
                            );
                            // Short text for the inline field label — the "Configuración Punto de
                            // Venta" column is too narrow to wrap the full message without clipping.
                            const invalidAmountFieldMessage = _('Monto inválido. Solo positivos.');
                            const invalidRangeFieldMessage = _('El mínimo no puede ser mayor al máximo.');
                            let rechargeAmountsValid = true;
                            if (!isValidRechargeAmount(minRecharge)) {
                                this.getRoot().markInvalid('MinimumRechargeAmount', invalidAmountFieldMessage);
                                rechargeAmountsValid = false;
                            } else {
                                // markInvalid(name, false) clears just this field;
                                // clearValidation() takes no argument and would reset the whole form.
                                this.getRoot().markInvalid('MinimumRechargeAmount', false);
                            }
                            if (!isValidRechargeAmount(maxRecharge)) {
                                this.getRoot().markInvalid('MaximumRechargeAmount', invalidAmountFieldMessage);
                                rechargeAmountsValid = false;
                            } else {
                                this.getRoot().markInvalid('MaximumRechargeAmount', false);
                            }
                            if (
                                rechargeAmountsValid &&
                                minRecharge !== '' &&
                                maxRecharge !== '' &&
                                parseFloat(minRecharge) > parseFloat(maxRecharge)
                            ) {
                                this.getRoot().markInvalid('MinimumRechargeAmount', invalidRangeFieldMessage);
                                this.getRoot().markInvalid('MaximumRechargeAmount', invalidRangeFieldMessage);
                                rechargeAmountsValid = false;
                            }
                            if (!rechargeAmountsValid) {
                                webix.message({
                                    title: _('¡Error!'),
                                    type: 'alert-error',
                                    text: isValidRechargeAmount(minRecharge) && isValidRechargeAmount(maxRecharge)
                                        ? invalidRangeMessage
                                        : invalidAmountMessage,
                                });
                                return;
                            }
                        }
                        if ($$('SpecialStatus') != undefined && $$('SpecialStatus').getValue() == 1) {
                            newdata.SpecialStatus = 'A'; // Set special status if active
                        } else {
                            newdata.SpecialStatus = 'I'; // Set special status if inactive
                        }
                        if ($$('Lockedsales') != undefined && $$('Lockedsales').getValue() == 1) {
                            newdata.Lockedsales = 'S'; // Set locked sales if active
                        } else {
                            newdata.Lockedsales = 'N'; // Set locked sales if inactive
                        }
                        if ($$('PrintReceiptBox') != undefined && $$('PrintReceiptBox').getValue() == 1) {
                            newdata.PrintReceiptBox = 'S'; // Set print receipt box if active
                        } else {
                            newdata.PrintReceiptBox = 'N'; // Set print receipt box if inactive
                        }
                        if ($$('AllowsRecharges') != undefined && $$('AllowsRecharges').getValue() == 1) {
                            newdata.AllowsRecharges = 'S'; // Set allows recharges if active
                        } else {
                            newdata.AllowsRecharges = 'N'; // Set allows recharges if inactive
                        }
                        if ($$('ActivateRegistration') != undefined && $$('ActivateRegistration').getValue() == 1) {
                            newdata.ActivateRegistration = 'S'; // Set activate registration if active
                        } else {
                            newdata.ActivateRegistration = 'N'; // Set activate registration if inactive
                        }
                        if ($$('IPIdentification') != undefined && $$('IPIdentification').getValue() == 1) {
                            newdata.IPIdentification = 'S'; // Set IP identification if active
                        } else {
                            newdata.IPIdentification = 'N'; // Set IP identification if inactive
                        }
                        if ($$('VisitMade') != undefined && $$('VisitMade').getValue() == 1) {
                            newdata.VisitMade = 'S'; // Set visit made if active
                        } else {
                            newdata.VisitMade = 'N'; // Set visit made if inactive
                        }
                        if ($$('DocumentationReceived') != undefined && $$('DocumentationReceived').getValue() == 1) {
                            newdata.DocumentationReceived = 'S'; // Set documentation received if active
                        } else {
                            newdata.DocumentationReceived = 'N'; // Set documentation received if inactive
                        }
                        if ($$('IndividualCalculation') != undefined && $$('IndividualCalculation').getValue() == 1) {
                            newdata.IndividualCalculation = 'S'; // Set individual calculation if active
                        } else {
                            newdata.IndividualCalculation = 'N'; // Set individual calculation if inactive
                        }
                        if ($$('DragNegatives') != undefined && $$('DragNegatives').getValue() == 1) {
                            newdata.DragNegatives = 'S'; // Set drag negatives if active
                        } else {
                            newdata.DragNegatives = 'N'; // Set drag negatives if inactive
                        }
                        if ($$('BetShopOwn') != undefined && $$('BetShopOwn').getValue() == 1) {
                            newdata.BetShopOwn = 'S'; // Set bet shop own if active
                        } else {
                            newdata.BetShopOwn = 'N'; // Set bet shop own if inactive
                        }
                        if ($$('BetShopType') != undefined && $$('BetShopType').getValue() == 1) {
                            newdata.BetShopType = 'F'; // Set bet shop type to F if active
                        } else {
                            newdata.BetShopType = 'V'; // Set bet shop type to V if inactive
                        }
                        if ($$('PhysicalPrize') != undefined && $$('PhysicalPrize').getValue() == 1) {
                            newdata.PhysicalPrize = 'S'; // Set physical prize if active
                        } else {
                            newdata.PhysicalPrize = 'N'; // Set physical prize if inactive
                        }
                        if ($$('CodeMinceturPv') !== undefined && $$('CodeMinceturPv').getValue() !== '') {
                            newdata.CodeMincetur = $$('CodeMinceturPv').getValue(); // Set Mincetur code if provided
                        } else {
                            newdata.CodeMincetur = ''; // Clear Mincetur code if not provided
                        }
                        delete newdata.CodeMinceturPv; // Remove temporary Mincetur code variable
                        if (devConfig.getPartnerSelected() == '8') { // Conditional logic for partner 8
                            if ($$('FacebookVerification') != undefined && $$('FacebookVerification').getValue() == 1) {
                                newdata.FacebookVerification = 'S'; // Set Facebook verification if active
                            } else {
                                newdata.FacebookVerification = 'N'; // Set Facebook verification if inactive
                            }
                            if ($$('InstagramVerification') != undefined && $$('InstagramVerification').getValue() == 1) {
                                newdata.InstagramVerification = 'S'; // Set Instagram verification if active
                            } else {
                                newdata.InstagramVerification = 'N'; // Set Instagram verification if inactive
                            }
                            if ($$('WhatsAppVerification') != undefined && $$('WhatsAppVerification').getValue() == 1) {
                                newdata.WhatsAppVerification = 'S'; // Set WhatsApp verification if active
                            } else {
                                newdata.WhatsAppVerification = 'N'; // Set WhatsApp verification if inactive
                            }
                            if (
                                $$('OtherSocialMediaVerification') != undefined &&
                                $$('OtherSocialMediaVerification').getValue() == 1
                            ) {
                                newdata.OtherSocialMediaVerification = 'S'; // Set other social media verification if active
                            } else {
                                newdata.OtherSocialMediaVerification = 'N'; // Set other social media verification if inactive
                            }
                        }
                        if ($$('IsActiveWithdrawalLimit').getValue() === 1) { // Check if withdrawal limit is active
                            if ($$('WithdrawalLimit').getValue() === '' || $$('WithdrawalLimit').getValue() <= 0) {
                                webix.message({
                                    title: _('¡Error!'),
                                    type: 'alert-error',
                                    text: _('El campo de límite de retiro es requerido con un valor mayor a 0'), // Error message for withdrawal limit
                                });
                                return; // Exit if validation fails
                            }
                            newdata.IsActivateWithdrawalLimit = 'A'; // Set withdrawal limit activation status
                            newdata.WithdrawalLimit = $$('WithdrawalLimit').getValue(); // Set withdrawal limit value
                        } else {
                            newdata.IsActivateWithdrawalLimit = 'I'; // Set withdrawal limit deactivation status
                            newdata.WithdrawalLimit = 0; // Reset withdrawal limit value
                        }
                        if ($$('IsActiveDepositLimit').getValue() === 1) { // Check if deposit limit is active
                            if ($$('DepositLimit').getValue() === '' || $$('DepositLimit').getValue() <= 0) {
                                webix.message({
                                    title: _('¡Error!'),
                                    type: 'alert-error',
                                    text: _('El campo de límite de depósito es requerido con un valor mayor a 0'), // Error message for deposit limit
                                });
                                return; // Exit if validation fails
                            }
                            newdata.IsActivateDepositLimit = 'A'; // Set deposit limit activation status
                            newdata.DepositLimit = $$('DepositLimit').getValue(); // Set deposit limit value
                        } else {
                            newdata.IsActivateDepositLimit = 'I'; // Set deposit limit deactivation status
                            newdata.DepositLimit = 0; // Reset deposit limit value
                        }
                        let concessionaireSelected = $$('IdsAllowed') // Get selected concessionaires
                            .serialize()
                            .filter((item) => item.ch1 === 'on'); // Filter selected items
                        if (concessionaireSelected.length > 0) {
                            newdata.IdsAllowed = concessionaireSelected.map((tag) => tag.id); // Map selected IDs
                        } else {
                            newdata.IdsAllowed = []; // Reset allowed IDs if none selected
                        }
                        if ($$('IsActivatePayWithdrawalAllies').getValue() === 1) {
                            newdata.IsActivatePayWithdrawalAllies = 'A'; // Set activation status for withdrawal payment for allies
                        } else {
                            newdata.IsActivatePayWithdrawalAllies = 'I'; // Set deactivation status for withdrawal payment for allies
                        }
                        if ($$('IsActiveWithdrawalLimitAllies').getValue() === 1) {
                            newdata.IsActiveWithdrawalLimitAllies = 'A'; // Set activation status for withdrawal limit for allies
                        } else {
                            newdata.IsActiveWithdrawalLimitAllies = 'I'; // Set deactivation status for withdrawal limit for allies
                        }
                        if ($$('WithdrawalLimitAllies').getValue() === '' || $$('WithdrawalLimitAllies').getValue() < 0) {
                            webix.message({
                                title: _('¡Error!'),
                                type: 'alert-error',
                                text: _('El campo de límite de retiro es requerido con un valor mayor o igual a 0'), // Error message for withdrawal limit for allies
                            });
                            return; // Exit if validation fails
                        } else {
                            newdata.WithdrawalLimitAllies = $$('WithdrawalLimitAllies').getValue(); // Set withdrawal limit for allies
                        }
                        if ($$('IsActiveDepositLimitAllies').getValue() === 1) {
                            newdata.IsActiveDepositLimitAllies = 'A'; // Set activation status for deposit limit for allies
                        } else {
                            newdata.IsActiveDepositLimitAllies = 'I'; // Set deactivation status for deposit limit for allies
                        }
                        if ($$('DepositLimitAllies').getValue() === '' || $$('DepositLimitAllies').getValue() < 0) {
                            webix.message({
                                title: _('¡Error!'),
                                type: 'alert-error',
                                text: _('El campo de límite de depósito es requerido con un valor mayor o igual a 0'), // Error message for deposit limit for allies
                            });
                            return; // Exit if validation fails
                        } else {
                            newdata.DepositLimitAllies = $$('DepositLimitAllies').getValue(); // Set deposit limit for allies
                        }
                        this.app.callEvent('betshop:update', [newdata]); // Trigger update event with new data
                    },
                },
            ],
        };

        // Set the Webix UI to full screen mode
        webix.ui.fullScreen();

        // Return a configuration object for a Webix form
        return {
            // Define the view type as 'form'
            view: 'form',

            // Unique identifier for the form
            id: 'formId',

            // Enable vertical scrolling
            scroll: 'y',

            // Apply custom CSS class to the form
            css: 'out',

            // Define the layout of the form with rows
            rows: [buttons, upper_section, upper_section_cashier],

            // Define validation rules for the form fields
            rules: {
                // Ensure the 'fname' field is not empty
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} form - The form object to initialize.
     */
    init(form) {
        // Initialize an empty array to hold concessionaire data
        let concessionaireList = [];

        // Hide the 'grav' element if the screen width is less than 500 pixels
        if (screen.width < 500) {
            $$('grav').hide();
        }

        // Get the localization service for translation purposes
        const _ = this.app.getService('locale')._;

        // Execute the following code when the webix library is ready
        webix.ready(function () {
            // Attach an event listener for screen rotation
            webix.attachEvent('onRotate', function (orientation) {
                // Reload the window on orientation change
                window.location.reload();
            });
        });

        // Store the current context (this) for use in callbacks
        var vthis = this;

        // Listen for the 'betshop:update' event on the app
        this.on(this.app, 'betshop:update', (data) => {
            // Perform an AJAX POST request to update the BetShop
            webix
                .ajax()
                .headers({
                    // Set the content type to JSON
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'BetShop/UpdateBetShop', data, {
                    // Define the error callback
                    error: function (text, data, XmlHttpRequest) {
                        // Display an error message if the request fails
                        webix.message(_('Error'));
                    },
                    // Define the success callback
                    success: function (text, data, XmlHttpRequest) {
                        // Parse the response text as JSON
                        var json = JSON.parse(text);
                        // Check if there was an error in the response
                        if (json.HasError) {
                            const rechargeErrorMessages = {
                                300544: _('Monto inválido. Solo positivos.'),
                                300545: _('El mínimo no puede ser mayor al máximo.'),
                                300546: _('El máximo no puede ser menor al mínimo.'),
                            };
                            if (rechargeErrorMessages[json.CodeError]) {
                                form.markInvalid('MinimumRechargeAmount', rechargeErrorMessages[json.CodeError]);
                                form.markInvalid('MaximumRechargeAmount', rechargeErrorMessages[json.CodeError]);
                            } else {
                                webix.message(_('Error'));
                            }
                        } else {
                            // Display a success message if the update was successful
                            webix.message(_('Guardado'));
                            // Reload the window to reflect changes
                            window.location.reload();
                        }
                    },
                });
        });
        // Event listener for 'form:update' event on the application instance
        this.on(this.app, 'form:update', (id) => {
            // Initiates an AJAX GET request to fetch client data by ID
            webix.ajax().get(
                devConfig.geturlApi() + 'Client/GetClientSpById', // API endpoint
                'id=' + id, // Query parameter with client ID
                {
                    // Error callback for AJAX request
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Display error message
                    },
                    // Success callback for AJAX request
                    success: function (text, data, XmlHttpRequest) {
                        text = JSON.parse(text); // Parse the JSON response
                        // Enable button if DNIA is present
                        if (text[0].DNIA) {
                            $$('buttonImage1').enable();
                        }
                        // Enable button if DNIP is present
                        if (text[0].DNIP) {
                            $$('buttonImage2').enable();
                        }
                        // Set value for SpecialStatus based on response
                        if (text[0].SpecialStatus == 'A') {
                            $$('SpecialStatus').setValue(1);
                        } else {
                            $$('SpecialStatus').setValue(0);
                        }
                        // Set value for Lockedsales based on response
                        if (text[0].Lockedsales == 'S') {
                            $$('Lockedsales').setValue(1);
                        } else {
                            $$('Lockedsales').setValue(0);
                        }
                        // Set value for PrintReceiptBox based on response
                        if (text[0].PrintReceiptBox == 'S') {
                            $$('PrintReceiptBox').setValue(1);
                        } else {
                            $$('PrintReceiptBox').setValue(0);
                        }
                        // Set value for AllowsRecharges based on response
                        if (text[0].AllowsRecharges == 'S') {
                            $$('AllowsRecharges').setValue(1);
                        } else {
                            $$('AllowsRecharges').setValue(0);
                        }
                        // Set value for ActivateRegistration based on response
                        if (text[0].ActivateRegistration == 'S') {
                            $$('ActivateRegistration').setValue(1);
                        } else {
                            $$('ActivateRegistration').setValue(0);
                        }
                        // Set value for IPIdentification based on response
                        if (text[0].IPIdentification == 'S') {
                            $$('IPIdentification').setValue(1);
                        } else {
                            $$('IPIdentification').setValue(0);
                        }
                        // Set value for VisitMade based on response
                        if (text[0].VisitMade == 'S') {
                            $$('VisitMade').setValue(1);
                        } else {
                            $$('VisitMade').setValue(0);
                        }
                        // Set value for DocumentationReceived based on response
                        if (text[0].DocumentationReceived == 'S') {
                            $$('DocumentationReceived').setValue(1);
                        } else {
                            $$('DocumentationReceived').setValue(0);
                        }
                        // Set value for IndividualCalculation based on response
                        if (text[0].IndividualCalculation == 'S') {
                            $$('IndividualCalculation').setValue(1);
                        } else {
                            $$('IndividualCalculation').setValue(0);
                        }
                        // Set value for DragNegatives based on response
                        if (text[0].DragNegatives == 'S') {
                            $$('DragNegatives').setValue(1);
                        } else {
                            $$('DragNegatives').setValue(0);
                        }
                        // Set value for BetShopOwn based on response
                        if (text[0].BetShopOwn == 'S') {
                            $$('BetShopOwn').setValue(1);
                        } else {
                            $$('BetShopOwn').setValue(0);
                        }
                        // Set value for BetShopType based on response
                        if (text[0].BetShopType == 'F') {
                            $$('BetShopType').setValue(1);
                        } else {
                            $$('BetShopType').setValue(0);
                        }
                        // Set value for PhysicalPrize based on response
                        if (text[0].PhysicalPrize == 'S') {
                            $$('PhysicalPrize').setValue(1);
                        } else {
                            $$('PhysicalPrize').setValue(0);
                        }
                        // Set value for CodeMinceturPv if defined and not empty
                        if (text[0].CodeMinceturPv !== undefined && text[0].CodeMinceturPv !== '') {
                            $$('CodeMinceturPv').setValue(text[0].CodeMinceturPv);
                        } else {
                            $$('CodeMinceturPv').setValue('');
                        }
                        // Check if the selected partner is '8' to set social media verification values
                        if (devConfig.getPartnerSelected() == '8') {
                            if (text[0].FacebookVerification == 'S') {
                                $$('FacebookVerification').setValue(1);
                            } else {
                                $$('FacebookVerification').setValue(0);
                            }
                            if (text[0].InstagramVerification == 'S') {
                                $$('InstagramVerification').setValue(1);
                            } else {
                                $$('InstagramVerification').setValue(0);
                            }
                            if (text[0].WhatsAppVerification == 'S') {
                                $$('WhatsAppVerification').setValue(1);
                            } else {
                                $$('WhatsAppVerification').setValue(0);
                            }
                            if (text[0].OtherSocialMediaVerification == 'S') {
                                $$('OtherSocialMediaVerification').setValue(1);
                            } else {
                                $$('OtherSocialMediaVerification').setValue(0);
                            }
                        }
                        // Update concessionaire list based on allowed IDs
                        if (text[0].IdsAllowed && text[0].IdsAllowed.length > 0) {
                            concessionaireList = concessionaireList.map((item) => {
                                if (text[0].IdsAllowed.includes(item.id)) {
                                    item.ch1 = 'on'; // Mark item as allowed
                                }
                                return item;
                            });
                            $$('IdsAllowed').parse(concessionaireList); // Parse updated list
                        }
                        // Set value for IsActivatePayWithdrawalAllies based on response
                        if (text[0].IsActivatePayWithdrawalAllies && text[0].IsActivatePayWithdrawalAllies === 'A') {
                            $$('IsActivatePayWithdrawalAllies').setValue(1);
                        } else {
                            $$('IsActivatePayWithdrawalAllies').setValue(0);
                        }
                        // Set value for IsActiveWithdrawalLimitAllies based on response
                        if (text[0].IsActiveWithdrawalLimitAllies && text[0].IsActiveWithdrawalLimitAllies === 'A') {
                            $$('IsActiveWithdrawalLimitAllies').setValue(1);
                        } else {
                            $$('IsActiveWithdrawalLimitAllies').setValue(0);
                        }
                        // Set value for IsActiveDepositLimitAllies based on response
                        if (text[0].IsActiveDepositLimitAllies && text[0].IsActiveDepositLimitAllies === 'A') {
                            $$('IsActiveDepositLimitAllies').setValue(1);
                        } else {
                            $$('IsActiveDepositLimitAllies').setValue(0);
                        }
                        // Set value for WithdrawalLimitAllies if valid
                        if (
                            text[0].WithdrawalLimitAllies &&
                            text[0].WithdrawalLimitAllies !== null &&
                            text[0].WithdrawalLimitAllies > 0
                        ) {
                            $$('WithdrawalLimitAllies').setValue(text[0].WithdrawalLimitAllies);
                        } else {
                            $$('WithdrawalLimitAllies').setValue(0);
                        }
                        // Set value for DepositLimitAllies if valid
                        if (
                            text[0].DepositLimitAllies &&
                            text[0].DepositLimitAllies !== null &&
                            text[0].DepositLimitAllies > 0
                        ) {
                            $$('DepositLimitAllies').setValue(text[0].DepositLimitAllies);
                        } else {
                            $$('DepositLimitAllies').setValue(0);
                        }
                        // Delay execution to allow UI updates before calling another event
                        webix.delay(
                            function () {
                                vthis.app.callEvent('betShopupdatedata', [
                                    text[0], // Pass the updated client data
                                ]);
                                $$('country').setValue(text[0].CountryId); // Set country value
                                webix.delay(
                                    function () {
                                        $$('currency').setValue(
                                            text[0].CurrencyId, // Set currency value
                                        );
                                        $$('ProvinceRegion').setValue(
                                            text[0].RegionId, // Set region value
                                        );
                                        webix.delay(
                                            function () {
                                                $$('City').setValue(
                                                    text[0].CityId, // Set city value
                                                );
                                                $$(
                                                    // Set concessionaire value
                                                    'Concessionaire',
                                                ).setValue(text[0].Concessionaire);
                                                $$(
                                                    // Set subconcessionaire value
                                                    'Subconcessionaire',
                                                ).setValue(text[0].Subconcessionaire);
                                            },
                                            '',
                                            '',
                                            1000, // Delay for 1 second
                                        );
                                    },
                                    '',
                                    '',
                                    1000, // Delay for 1 second
                                );
                            },
                            '',
                            '',
                            1000, // Delay for 1 second
                        );
                    },
                },
            );
        });
        webix
            .ajax() // Initiates an AJAX request using Webix
            .headers({
                'Content-type': 'application/json', // Sets the content type to JSON for the request
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                // Sends a POST request to get agent countries
                error: function (text, data, XmlHttpRequest) {
                    // Callback for handling errors
                    webix.message(_('Error! ')); // Displays an error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Callback for handling successful responses
                    var data = JSON.parse(
                        // Parses the JSON response
                        text
                            .replace(/"Id"/g, '"id"') // Replaces "Id" with "id" for consistency
                            .replace(/"Name"/g, '"value"'), // Replaces "Name" with "value" for consistency
                    );
                    var optionsCountries = $$('country').getList(); // Retrieves the list of countries
                    optionsCountries.clearAll(); // Clears the existing options in the list
                    optionsCountries.parse(data.Data); // Parses and populates the list with new data
                    webix
                        .ajax() // Initiates another AJAX request
                        .headers({
                            'Content-type': 'application/json', // Sets the content type to JSON for the request
                        })
                        .post(
                            devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels2', // Sends a POST request to get agents
                            '',
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    // Callback for handling errors
                                    webix.message(_('Error! ')); // Displays an error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    // Callback for handling successful responses
                                    var data = JSON.parse(
                                        // Parses the JSON response
                                        text
                                            .replace(/"Id"/g, '"id"') // Replaces "Id" with "id" for consistency
                                            .replace(/"Name"/g, '"value"'), // Replaces "Name" with "value" for consistency
                                    );
                                    if (data.Data.Children == null) {
                                        // Checks if there are no children in the data
                                        $$('Concessionaire').hide(); // Hides the Concessionaire element
                                        $$('Subconcessionaire').hide(); // Hides the Subconcessionaire element
                                        $$('Subconcessionaire2').hide(); // Hides the Subconcessionaire2 element
                                    } else {
                                        var options = $$('Concessionaire').getList(); // Retrieves the list of concessionaires
                                        options.clearAll(); // Clears the existing options in the list
                                        if (
                                            devConfig.getPermAction(
                                                // Checks if the user has permission to clear subconcessionaires
                                                'clearSubconcessionaire',
                                                'Add',
                                            )
                                        ) {
                                            data.Data.Children.unshift({
                                                // Adds a default option to the beginning of the list
                                                id: '',
                                                value: _(
                                                    'Clic para seleccionar', // Placeholder text for selection
                                                ),
                                            });
                                        }
                                        options.parse(data.Data.Children); // Parses and populates the list with new data
                                    }
                                    let concessionaire = $$('IdsAllowed'); // Retrieves the list of allowed concessionaires
                                    concessionaireList = data.Data.Children.map(
                                        // Maps the children data to a new format
                                        (item) => {
                                            return {
                                                id: item.id, // Maps the id
                                                title: item.value, // Maps the title
                                            };
                                        },
                                    );
                                    concessionaireList.shift(); // Removes the first element from the list
                                    concessionaire.parse(concessionaireList); // Parses and populates the list with new data
                                    vthis.app.callEvent('form:update', [
                                        // Calls an event to update the form
                                        vthis.getParam('user', true), // Passes the user parameter
                                    ]);
                                },
                            },
                        );
                },
            });
        // Initiates an AJAX request to fetch the types of establishments
        webix
            .ajax()
            .headers({
                // Sets the content type of the request to JSON
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'BetShop/GetTypeEstablishment', '', {
                // Callback function executed on error
                error: function (text, data, XmlHttpRequest) {
                    // Displays an error message to the user
                    webix.message(_('Error! '));
                },
                // Callback function executed on successful response
                success: function (text, data, XmlHttpRequest) {
                    // Parses the JSON response text
                    var data = JSON.parse(text);
                    // Retrieves the list of type establishments
                    var optionsTypeEstablishment = $$('TypeEstablishment').getList();
                    // Clears any existing options in the list
                    optionsTypeEstablishment.clearAll();
                    // Parses and adds new data to the list
                    optionsTypeEstablishment.parse(data.Data);
                },
            });

        // Initiates another AJAX request to fetch zones
        webix
            .ajax()
            .headers({
                // Sets the content type of the request to JSON
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'BetShop/GetZones', '', {
                // Callback function executed on error
                error: function (text, data, XmlHttpRequest) {
                    // Displays an error message to the user
                    webix.message(_('Error! '));
                },
                // Callback function executed on successful response
                success: function (text, data, XmlHttpRequest) {
                    // Parses the JSON response text
                    var data = JSON.parse(text);
                    // Retrieves the list of zones
                    var optionsZones = $$('Zone').getList();
                    // Clears any existing options in the list
                    optionsZones.clearAll();
                    // Parses and adds new data to the list
                    optionsZones.parse(data.Data);
                },
            });
        // Listen for the 'betShopupdatedata' event on the application instance
        this.on(this.app, 'betShopupdatedata', (person) => {
            // Check if the person type is 'CAJERO'
            if (person.Type == 'CAJERO') {
                // Show the upper section for cashier
                $$('upper_section_cashier').show();
                // Remove view 'b5' from the form
                $$('formId').removeView('b5');
            } else {
                // Remove the upper section for cashier from the form
                $$('formId').removeView('upper_section_cashier');
                // Show the 'b5' view
                $$('b5').show();
            }
            // Set form values based on the person object
            form.setValues(person);
            // Check if withdrawal limit is activated
            if (person.IsActivateWithdrawalLimit === 'A') {
                // Set the withdrawal limit active flag
                $$('IsActiveWithdrawalLimit').setValue(1);
                // Show the withdrawal limit field
                $$('WithdrawalLimit').show();
                // Set the withdrawal limit value if valid
                if (person.WithdrawalLimit !== null && person.WithdrawalLimit > 0) {
                    $$('WithdrawalLimit').setValue(person.WithdrawalLimit);
                } else {
                    // Default to 0 if no valid limit is provided
                    $$('WithdrawalLimit').setValue(0);
                }
            } else {
                // Set the withdrawal limit inactive flag
                $$('IsActiveWithdrawalLimit').setValue(0);
                // Hide the withdrawal limit field
                $$('WithdrawalLimit').hide();
            }
            // Check if deposit limit is activated
            if (person.IsActivateDepositLimit === 'A') {
                // Set the deposit limit active flag
                $$('IsActiveDepositLimit').setValue(1);
                // Show the deposit limit field
                $$('DepositLimit').show();
                // Set the deposit limit value if valid
                if (person.DepositLimit !== null && person.DepositLimit > 0) {
                    $$('DepositLimit').setValue(person.DepositLimit);
                } else {
                    // Default to 0 if no valid limit is provided
                    $$('DepositLimit').setValue(0);
                }
            } else {
                // Set the deposit limit inactive flag
                $$('IsActiveDepositLimit').setValue(0);
                // Hide the deposit limit field
                $$('DepositLimit').hide();
            }
            // Enable the save button if the user has permission to update the betshop
            if (devConfig.getPermAction('btnUpdateBetshop', 'Add')) {
                $$('buttonSave').enable();
            }
        });
        // Listen for the 'person:select' event and set form values based on the selected person
        this.on(this.app, 'person:select', (person) => form.setValues(person));

        // Attach an event listener for changes in the 'country' dropdown
        $$('country').attachEvent('onChange', function (newv, oldv) {
            // Get the selected country's options
            var optionscountries = this.getList().getItem(newv);
            // Check if the selected country is defined
            if (optionscountries != undefined) {
                // Get the currency list and clear existing options
                var optionscurrencies = $$('currency').getList();
                optionscurrencies.clearAll();
                // Parse and populate the currency options based on the selected country
                optionscurrencies.parse(optionscountries.currencies);

                // Get the ProvinceRegion list and clear existing options
                var optionsProvinceRegions = $$('ProvinceRegion').getList();
                optionsProvinceRegions.clearAll();
                // Parse and populate the ProvinceRegion options based on the selected country
                optionsProvinceRegions.parse(optionscountries.departments);
            }
        });

        // Attach an event listener for changes in the 'ProvinceRegion' dropdown
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            // Get the selected province region's options
            var optionsProvinceRegions = this.getList().getItem(newv);
            // Get the City list and clear existing options
            var optionsCity = $$('City').getList();
            optionsCity.clearAll();
            // Check if the selected province region is defined
            if (optionsProvinceRegions != undefined) {
                // Parse and populate the city options based on the selected province region
                optionsCity.parse(optionsProvinceRegions.cities);
            }
        });

        // Attach an event listener for changes in the 'Concessionaire' dropdown
        $$('Concessionaire').attachEvent('onChange', function (newv, oldv) {
            // Get the selected province region's options
            var optionsProvinceRegions = this.getList().getItem(newv);
            // Get the Subconcessionaire list and clear existing options
            var optionsCity = $$('Subconcessionaire').getList();
            optionsCity.clearAll();
            // Check if the selected province region is defined
            if (optionsProvinceRegions != undefined) {
                // Parse and populate the Subconcessionaire options based on the selected province region
                optionsCity.parse(optionsProvinceRegions.Children);
            }
            // Check permissions and clear Subconcessionaire fields if applicable
            if (devConfig.getPermAction('clearSubconcessionaire', 'Add')) {
                $$('Subconcessionaire').setValue('');
                $$('Subconcessionaire2').setValue('');
            }
        });
        $$('Subconcessionaire').attachEvent('onChange', function (newv, oldv) {
            // Retrieve the list of province regions based on the new value selected
            var optionsProvinceRegions = this.getList().getItem(newv);
            // Get the list of cities associated with the second subconcessionaire
            var optionsCity = $$('Subconcessionaire2').getList();
            // Clear all existing options in the city list
            optionsCity.clearAll();
            // Check if the province regions options are defined
            if (optionsProvinceRegions != undefined) {
                // Parse and populate the city list with children of the selected province region
                optionsCity.parse(optionsProvinceRegions.Children);
            }
            // Check if the user has permission to clear the subconcessionaire field
            if (devConfig.getPermAction('clearSubconcessionaire', 'Add')) {
                // Clear the value of the second subconcessionaire field
                $$('Subconcessionaire2').setValue('');
            }
        });

        // Perform an AJAX request to fetch account options
        webix
            .ajax()
            .headers({
                // Set the content type for the request to JSON
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetAccountsSelect', '', {
                // Handle error response
                error: function (text, data, XmlHttpRequest) {
                    // Display an error message to the user
                    webix.message('Error! ');
                },
                // Handle successful response
                success: function (text, data, XmlHttpRequest) {
                    // Parse the JSON response
                    var resp = JSON.parse(text);
                    // Define options for the AccountFilter dropdown with the received data
                    $$('AccountFilter').define('options', resp.Data);
                    // Refresh the AccountFilter dropdown to reflect new options
                    $$('AccountFilter').refresh();
                    // Define options for the AccountCloseFilter dropdown with the same data
                    $$('AccountCloseFilter').define('options', resp.Data);
                    // Refresh the AccountCloseFilter dropdown to reflect new options
                    $$('AccountCloseFilter').refresh();
                },
            });
    }

    /**
     * Retrieves localized options for combo boxes and updates their lists.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Getting localization function
        let p_options = webix.copy(getPositions()); // Copying position options
        p_options.map((x) => (x.value = _(x.value))); // Localizing position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parsing position options into the combo

        let t_options = webix.copy(getTags()); // Copying tag options
        t_options.map((x) => (x.value = _(x.value))); // Localizing tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parsing tag options into the combo

        let c_options = webix.copy(getCities()); // Copying city options
        c_options.map((x) => (x.value = _(x.value))); // Localizing city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parsing city options into the combo
    }
}

// Extending Webix UI with a custom template
webix.protoUI(
    {
        name: 'template2', // Name of the custom template
        /**
         * Retrieves the values from the template.
         * @returns {Object} The values of the template.
         */
        getValue: function () {
            return this.getValues(); // Getting values from the template
        },
        /**
         * Sets the values for the template.
         * @param {Object} value - The values to set in the template.
         */
        setValue: function (value) {
            this.setValues(value); // Setting values in the template
        },
    },
    webix.ui.template, // Extending the Webix template UI
);

// FILE DOCUMENTED
